module.exports = __webpack_public_path__ + "img/index_icon01.f0453cda.png";